import { allReportingTargetDefinitions } from './definitions/all-reporting-targets';
import type { ReportingTargetFilterDefinition } from './reporting-target-filter.types';

function unknownTargetDefinition(targetId: string): ReportingTargetFilterDefinition {
    return {
        targetId,
        displayName: targetId,
        fetchImplemented: false,
        commonFilterFields: [],
        targetFilterFields: [],
        emptyTargetFiltersMessage: `No filters are available for “${targetId}”.`,
    };
}

const DEFAULT_DEFINITIONS: ReadonlyMap<string, ReportingTargetFilterDefinition> = new Map(
    allReportingTargetDefinitions.map((definition) => [definition.targetId, definition])
);

/**
 * Maps reporting target ids to filter metadata. Use {@link getFilterByReportingTarget} with
 * `renderReportingTargetPanels` to build UI and drive fetch dispatch.
 */
export class ReportingTargetFilterRegistry {
    constructor(
        private readonly definitions: ReadonlyMap<
            string,
            ReportingTargetFilterDefinition
        > = DEFAULT_DEFINITIONS
    ) {}

    /**
     * Returns the filter definition for a target. Unknown ids get a stub (`fetchImplemented: false`).
     */
    getFilterByReportingTarget(targetId: string): ReportingTargetFilterDefinition {
        return this.definitions.get(targetId) ?? unknownTargetDefinition(targetId);
    }
}
